import { Box, Flex, Progress, Spinner, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import useAiUsage from '../../hooks/useAiUsage';
import { resetsText, WARN_AT } from '../../utils/aiUsage';

const WINDOWS = [
  { key: 'day', labelKey: 'plan.today' },
  { key: 'month', labelKey: 'plan.thisMonth' },
];

function UsageBar({ label, window, use }) {
  const { t } = useTranslation('settings');
  const full = use.percent >= 100;
  const near = !full && use.percent >= WARN_AT;
  return (
    <Box py={3} borderBottom="1px solid" borderColor="redesign.border" _last={{ borderBottom: 'none' }}>
      <Flex justify="space-between" align="baseline" mb={2}>
        <Text fontSize="sm" fontWeight={500} color="redesign.heading">{label}</Text>
        <Text fontSize="sm" color={full ? 'red.500' : near ? 'redesign.text.warn' : 'redesign.text.muted'}>{use.percent}%</Text>
      </Flex>
      <Progress
        value={use.percent}
        size="sm"
        borderRadius="full"
        colorScheme={full ? 'red' : near ? 'orange' : 'blue'}
        bg="redesign.bg.sunken"
        aria-label={label}
      />
      <Text fontSize="xs" color="redesign.text.muted" mt={1.5}>
        {resetsText(t, window, use.resets_at)}
      </Text>
    </Box>
  );
}

// Today's and this month's AI usage as two bars, a percentage and when each
// resets (MI-354): what the Plan section shows, on the desktop and the phone.
// No dollars, tokens or credits: the API sends none.
export default function AiUsageBars() {
  const { t } = useTranslation('settings');
  const { usage, loading, error } = useAiUsage();

  if (loading) {
    return <Flex py={4} justify="center"><Spinner size="sm" color="redesign.text.muted" /></Flex>;
  }
  const shown = WINDOWS.filter((w) => usage?.[w.key]);
  if (error || !usage || !shown.length) {
    return (
      <Text fontSize="sm" color="redesign.text.muted" py={4}>
        {t(error || !usage ? 'plan.error' : 'plan.noLimit')}
      </Text>
    );
  }
  return shown.map((w) => (
    <UsageBar key={w.key} label={t(w.labelKey)} window={w.key} use={usage[w.key]} />
  ));
}
